import { render } from "./webClue.vue?vue&type=template&id=2a6c7559&scoped=true"
import script from "./webClue.vue?vue&type=script&lang=js"
export * from "./webClue.vue?vue&type=script&lang=js"

import "./webClue.vue?vue&type=style&index=0&id=2a6c7559&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a6c7559"

export default script